import React from "react";
import { default as MUIRating } from "@mui/material/Rating";
import styled from "styled-components";

const StyledMUIRating = styled(MUIRating)``;

/**
 * Rating component based on Material-UI's Rating, with additional styling.
 *
 * @component
 *
 * @param {number} [precision=1] - The granularity of the rating (e.g., 0.5 allows half-star ratings).
 * @param {number} value - The current rating value.
 * @param {function} onChange - Callback function triggered when the rating value changes.
 * @param {("small"|"medium"|"large")} size - The size of the rating component. One of "small", "medium", or "large".
 * @param {number} [max=5] - The maximum rating value.
 * @param {boolean} [readOnly=false] - If true, the rating component is read-only and cannot be changed.
 *
 * @returns {JSX.Element} The styled rating component.
 */
export const Rating = ({
  precision = 1,
  value,
  onChange,
  size,
  max = 5,
  readOnly = false,
}) => {
  return (
    <StyledMUIRating
      value={value}
      onChange={onChange}
      precision={precision}
      size={size}
      max={max}
      readOnly={readOnly}
    />
  );
};
